import { Link } from 'react-router-dom';
import Plans from './Plans';
import styles from './Home.module.css';

function Home() {
    return (
        <div className={styles.home}>
            <main>
                {/* HERO */}
                <section className={styles.hero}>
                    <div className={styles.container}>

                        <div className={styles.heroContent}>

                            <div className={styles.badge}>
                                🎁 Teste grátis por 7 dias
                            </div>

                            <h1>
                                Tenha o controle completo
                                <span> do seu criatório</span>
                            </h1>

                            <p>
                                Organize suas aves, acompanhe suas gaiolas
                                e controle todo o processo de reprodução
                                em um único lugar.
                            </p>

                            <div className={styles.heroButtons}>

                                <Link
                                    to="/register"
                                    className={styles.primaryButton}
                                >
                                    Começar agora
                                </Link>

                                <Link
                                    to="/login"
                                    className={styles.secondaryButton}
                                >
                                    Já tenho uma conta
                                </Link>

                            </div>

                            <div className={styles.heroInfo}>
                                <span>✓ 7 dias grátis</span>
                                <span>✓ Sem compromisso</span>
                                <span>✓ Cancele quando quiser</span>
                            </div>

                        </div>


                        {/* PREVIEW DO SISTEMA */}
                        <div className={styles.previewWrapper}>

                            <div className={styles.preview}>

                                <div className={styles.previewHeader}>

                                    <div>
                                        <strong>
                                            🐦 Reprodução
                                        </strong>

                                        <small>
                                            Controle de aves
                                        </small>
                                    </div>

                                    <span className={styles.active}>
                                        ● Sistema ativo
                                    </span>

                                </div>


                                <div className={styles.previewMenu}>
                                    <span className={styles.activeMenu}>
                                        🏠 Gaiolas
                                    </span>

                                    <span>
                                        🐦 Aves
                                    </span>

                                    <span>
                                        🥚 Reprodução
                                    </span>
                                </div>


                                <div className={styles.previewTitle}>

                                    <small>
                                        CONTROLE
                                    </small>

                                    <h3>
                                        Minhas gaiolas
                                    </h3>

                                    <p>
                                        Acompanhe a reprodução de cada casal.
                                    </p>

                                </div>


                                <div className={styles.cages}>

                                    <div className={styles.cage}>

                                        <div className={styles.cageTop}>
                                            <span>
                                                Gaiola 01
                                            </span>

                                            <b className={styles.status}>
                                                Ativo
                                            </b>
                                        </div>

                                        <div className={styles.birds}>
                                            🐦
                                            <span>♂</span>

                                            <span>+</span>

                                            🐦
                                            <span>♀</span>
                                        </div>

                                        <small>
                                            Reprodução em andamento
                                        </small>

                                    </div>


                                    <div className={styles.cage}>

                                        <div className={styles.cageTop}>
                                            <span>
                                                Gaiola 02
                                            </span>

                                            <b className={styles.waiting}>
                                                Aguardando
                                            </b>
                                        </div>

                                        <div className={styles.birds}>
                                            🐦
                                            <span>♂</span>

                                            <span>+</span>

                                            🐦
                                            <span>♀</span>
                                        </div>

                                        <small>
                                            Casal cadastrado
                                        </small>

                                    </div>

                                </div>


                                <div className={styles.previewBirds}>

                                    <small>
                                        PLANTEL
                                    </small>

                                    <div className={styles.birdTitle}>

                                        <div>
                                            <h3>
                                                Minhas aves
                                            </h3>

                                            <p>
                                                Consulte informações e genealogia.
                                            </p>
                                        </div>

                                        <strong>
                                            12 aves
                                        </strong>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                </section>


                {/* RECURSOS */}
                <section className={styles.features}>
                    <div className={styles.container}>

                        <div className={styles.sectionHeader}>

                            <span>
                                RECURSOS
                            </span>

                            <h2>
                                Tudo o que você precisa
                                para organizar seu criatório
                            </h2>

                            <p>
                                Tenha todas as informações importantes
                                das suas aves organizadas e acessíveis.
                            </p>

                        </div>


                        <div className={styles.featureGrid}>

                            <div className={styles.feature}>

                                <div className={styles.featureIcon}>
                                    🏠
                                </div>

                                <h3>
                                    Controle de gaiolas
                                </h3>

                                <p>
                                    Cadastre suas gaiolas e acompanhe
                                    os casais e os processos de reprodução.
                                </p>

                            </div>


                            <div className={styles.feature}>

                                <div className={styles.featureIcon}>
                                    🐦
                                </div>

                                <h3>
                                    Cadastro de aves
                                </h3>

                                <p>
                                    Mantenha as informações das suas aves
                                    organizadas e tenha acesso rápido
                                    ao seu plantel.
                                </p>

                            </div>


                            <div className={styles.feature}>

                                <div className={styles.featureIcon}>
                                    🥚
                                </div>

                                <h3>
                                    Acompanhamento da reprodução
                                </h3>

                                <p>
                                    Acompanhe cada reprodução e registre
                                    as informações importantes de cada casal.
                                </p>

                            </div>


                            <div className={styles.feature}>

                                <div className={styles.featureIcon}>
                                    🧬
                                </div>

                                <h3>
                                    Genealogia
                                </h3>

                                <p>
                                    Consulte a origem das suas aves e
                                    mantenha o histórico do seu plantel.
                                </p>

                            </div>

                        </div>

                    </div>
                </section>


                {/* PLANOS */}
                <Plans />


                {/* CTA */}
                <section className={styles.cta}>
                    <div className={styles.container}>

                        <div className={styles.ctaContent}>

                            <div>

                                <span>
                                    COMECE AGORA
                                </span>

                                <h2>
                                    Organize seu criatório
                                    de forma simples.
                                </h2>

                                <p>
                                    Crie sua conta e tenha 7 dias grátis
                                    para conhecer todos os recursos.
                                </p>

                            </div>

                            <Link
                                to="/register"
                                className={styles.ctaButton}
                            >
                                Criar minha conta →
                            </Link>

                        </div>

                    </div>
                </section>

            </main>


            {/* FOOTER */}
            <footer className={styles.footer}>
                <div className={styles.container}>

                    <div className={styles.footerLogo}>

                        <span>
                            🐦
                        </span>

                        <div>
                            <strong>
                                Reprodução
                            </strong>

                            <small>
                                Controle de aves
                            </small>
                        </div>

                    </div>

                    <p>
                        Controle seu criatório de forma simples
                        e organizada.
                    </p>



                </div>
            </footer>

        </div>
    );
}

export default Home;